module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    class: {
      'has-error': _vm.hasError
    }
  }, [_vm._t("label"), _vm._v(" "), (((_vm.attrs).type) === 'checkbox') ? _c('input', _vm._g(_vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input),
      expression: "input"
    }],
    class: _vm.classes,
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.input) ? _vm._i(_vm.input, null) > -1 : (_vm.input)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.input,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.input = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.input = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.input = $$c
        }
      }
    }
  }, 'input', _vm.attrs, false), _vm.listeners)) : (((_vm.attrs).type) === 'radio') ? _c('input', _vm._g(_vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input),
      expression: "input"
    }],
    class: _vm.classes,
    attrs: {
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.input, null)
    },
    on: {
      "change": function($event) {
        _vm.input = null
      }
    }
  }, 'input', _vm.attrs, false), _vm.listeners)) : _c('input', _vm._g(_vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input),
      expression: "input"
    }],
    class: _vm.classes,
    attrs: {
      "type": (_vm.attrs).type
    },
    domProps: {
      "value": (_vm.input)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input = $event.target.value
      }
    }
  }, 'input', _vm.attrs, false), _vm.listeners)), _vm._v(" "), _c('div', {
    staticClass: "error"
  }, [_vm._v("\n    " + _vm._s(_vm.messageError) + "\n  ")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12afe4d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Forms/VUploadField.vue
// module id = 1660
// module chunks = 2